import axios from 'axios'
import {
    TOKEN_TYPE,
    REQUEST_HEADER_AUTH_KEY,
} from 'shared/constants/api.constants'
import { getAccessToken } from './authToken'

export const createHttpClient = (initConfig) => {
    const axiosInstance = axios.create({
        headers: { 'Content-Type': 'application/json' },
        ...initConfig,
    })

    axiosInstance.interceptors.request.use(
        async function (config) {
            const accessToken = getAccessToken()

            if (accessToken) {
                config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`
            }

            return config
        },
        function (error) {
            return Promise.reject(error)
        }
    )

    axiosInstance.interceptors.response.use(
        function (response) {
            return response
        },
        function (error) {
            return Promise.reject(error)
        },
        { synchronous: true }
    )

    return axiosInstance
}
